import React from 'react';
import { Table, Button } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';

// Lista de destinatários elegíveis (anti-duplicata 9 dias já aplicada no backend).
// PorContrato exibe a coluna Contrato; PorCpf exibe a coluna CPF.
// Remoção individual = UX opcional ([VALIDAR], não é RN-14 — RN-14 é RemoveAcento no backend).
const ListaDestinatarios = ({ destinatarios, tipoDisparo, onRemover }) => {
  const porContrato = tipoDisparo === 'PorContrato';
  const lista = destinatarios || [];

  if (lista.length === 0) {
    return (
      <div className="text-muted text-center p-3">
        Nenhum destinatário encontrado.
      </div>
    );
  }

  const chaveDe = (d) =>
    porContrato ? `c-${d.codigo_boleto}` : `p-${d.cpf}`;

  return (
    <div style={{ maxHeight: 420, overflowY: 'auto' }}>
      <Table striped bordered hover size="sm" className="mb-0">
        <thead>
          <tr>
            <th>{porContrato ? 'Contrato' : 'CPF'}</th>
            <th>Nome</th>
            <th>Telefone</th>
            {onRemover && <th style={{ width: 60 }} className="text-center">Ações</th>}
          </tr>
        </thead>
        <tbody>
          {lista.map((d) => (
            <tr key={chaveDe(d)}>
              <td>{porContrato ? d.nr_contrato : d.cpf}</td>
              <td>{d.nome}</td>
              <td>{d.telefone_normalizado}</td>
              {onRemover && (
                <td className="text-center">
                  <Button
                    variant="outline-danger"
                    size="sm"
                    title="Remover destinatário"
                    onClick={() => onRemover(chaveDe(d))}
                  >
                    <FaTrash />
                  </Button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default ListaDestinatarios;
